import { sidenavComponent } from './sidenav.component';
import * as angular from "angular";

export default angular
    .module("board.web.admin.sidenav", [])
    .component("brdSidenav", sidenavComponent)
    .name;


// WEBPACK FOOTER //
// ./app/layout/sidenav/sidenav.module.ts